import { StandardProps } from "@/types/types";
import {
  findFirstMatchingDimensionNameInFacets,
  getPrimaryFacetDisplayName,
  constants,
} from "@/utils/facet";
import { useFeatureFlags } from "@/flags/flags";
import { FilterDrawerButton } from "../FilterDrawerButton/FilterDrawerButton";
import styles from "./PrimaryFacet.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export function PrimaryFacet({
  productListingData,
  configProps,
}: Pick<StandardProps, "productListingData" | "configProps">) {
  const flags = useFeatureFlags();
  const { facets } = productListingData;

  if (flags.isHidePrimaryFacetFlagOn?.value) return null;

  const dimensionNamesToSearchFor = [
    constants.AGE_RANGE_DIMENSION_NAME,
    constants.WOMENS_SIZE_DIMENSION_NAME,
    constants.MENS_SIZE_DIMENSION_NAME,
  ];

  const { matchingFacetName, matchingDimensionName } =
    findFirstMatchingDimensionNameInFacets(dimensionNamesToSearchFor, facets);

  const displayName = matchingFacetName
    ? getPrimaryFacetDisplayName({
        matchingFacetName,
        matchingDimensionName,
      })
    : undefined;

  if (!displayName) return null;

  return (
    <div
      data-component="PrimaryFacet"
      className={cx("primaryFacet", {
        "primaryFacet--mobile-only": !!configProps?.mobileOnly,
      })}
    >
      <FilterDrawerButton
        data-testid="primary-facet-button"
        productListingData={productListingData}
        configProps={configProps}
        name={displayName}
        targetFacetName={matchingFacetName}
      />
    </div>
  );
}
